/* eslint-disable unused-imports/no-unused-imports-ts */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {makeAutoObservable} from 'mobx';

import Phase1Api from '../../api/phases/phase1Api';
import updateField from '../../helpers/updateField';
import {serializable} from '../sync/serialization';
import {HouseholdIncomeRange} from '@amplify/athena-models';

class Phase1 {
    @serializable()
    features = ['savings'];

    @serializable()
    intentGoals = '';

    @serializable()
    wealthGoals = [];

    @serializable()
    protectionGoals = [];

    @serializable()
    growFundingPlan = '';

    @serializable()
    coverageType = '';

    @serializable()
    cashValueImportance = '';

    @serializable()
    growCashValue = 500000;

    @serializable()
    investmentVehicles = [];

    @serializable()
    taxAdvantagedAccounts = [];

    @serializable()
    healthEmergencySavings = 50000;

    @serializable()
    incomeDependents = '';

    @serializable()
    mortgageAmount = 100000;

    @serializable()
    numberOfChildren = '';

    @serializable()
    coverageScenarios = [];

    @serializable()
    startIntent: 'today' | 'next1to2Months' | 'nextYear' | 'unsure' | '' = '';

    @serializable()
    overallHealth = '';

    @serializable()
    dateOfBirth = '';

    @serializable()
    dateOfBirthMixpanel = '';

    @serializable()
    zipCode = '';

    @serializable()
    zipCodeId = 5;

    @serializable()
    zipCodeState = 'California';

    @serializable()
    gender = '';

    @serializable()
    maritalStatus = '';

    @serializable()
    military: boolean | null = null;

    @serializable()
    annualHouseholdIncome: '' | HouseholdIncomeRange = '';

    @serializable()
    annualHouseholdIncomeText = '';

    @serializable()
    annualHouseholdIncomeNumeric = 0;

    @serializable()
    annualIndividualIncome = 0;

    @serializable()
    estimatedSavingTotal = 0;

    @serializable()
    travellingOut: boolean | null = null;

    @serializable()
    estimatedDebtTotal = 0;

    @serializable()
    prevOccupation = '';
    // Unemployed

    @serializable()
    employmentStatus = '';

    @serializable()
    unemploymentReasonType = '';

    @serializable()
    unemploymentReasonDesc = '';

    @serializable()
    prevEmployer = '';

    @serializable()
    workExpirienceYears = '';

    @serializable()
    workExpirienceMonths = '';

    // Retired
    @serializable()
    currIncomeDetails = '';

    @serializable()
    ageOfRetirement = '';

    // Student
    @serializable()
    schoolName = '';

    @serializable()
    grade = '';

    // On Disability
    @serializable()
    termSSDI = '';

    @serializable()
    amplifyVulPrequalify: boolean | null = null;

    @serializable()
    extremeSports = [];

    @serializable()
    usCitizen: boolean | null = null;

    @serializable()
    comfortableAmount = 0;

    @serializable()
    investmentRisk: 'high' | 'moderate' | 'low' | '' = '';

    constructor() {
        makeAutoObservable(this);
    }

    updateField = updateField.bind(this);

    get showNonAmplifyPrequalifyQuestion(): boolean {
        return this.amplifyVulPrequalify !== true;
    }

    get intentBuilderResult(): 'IUL' | 'TERM' | 'ANNUITY' | undefined {
        const {intentGoals, wealthGoals, protectionGoals, coverageType, cashValueImportance} = this;

        const fundingPlanIncludes = (val: string): boolean => {
            const fp = this.growFundingPlan as unknown;
            return Array.isArray(fp) ? (fp as string[]).includes(val) : fp === val;
        };

        const annuityTripWireGrow = (): boolean => {
            const notLooking = (protectionGoals as string[]).includes('notLooking');
            const nearTermRetirement = (wealthGoals as string[]).includes('nearTermRetirement');
            const rollover = fundingPlanIncludes('lumpSumRetirement');
            return notLooking && (nearTermRetirement || rollover);
        };

        const protectResult = (): 'IUL' | 'TERM' | undefined => {
            if (coverageType === 'temporary' && cashValueImportance === 'notNeeded') return 'TERM';
            if (
                coverageType === 'permanent' ||
                coverageType === 'notSure' ||
                ['important', 'niceToHave', 'notSure'].includes(cashValueImportance)
            )
                return 'IUL';
            return undefined;
        };

        if (intentGoals === 'growth') {
            return annuityTripWireGrow() ? 'ANNUITY' : 'IUL';
        }

        if (intentGoals === 'protection') {
            return protectResult();
        }

        if (intentGoals === 'both') return 'IUL';

        return undefined;
    }

    checkZipCode = async (usersZipcode?: string): Promise<string> => {
        try {
            const res = await Phase1Api.checkZipCode(!!usersZipcode ? usersZipcode : this.zipCode);
            if (!!res?.name) {
                this.updateField('zipCodeId', res.id);
                this.updateField('zipCodeState', res.name);
                return '';
            } else {
                return 'Incorrect state';
            }
        } catch (e) {
            console.log(e);
        }
    };
}

export default Phase1;
